import { apiRequest } from 'utils/request'

export const getVehicleComments = ({ serialNumber }) =>
  apiRequest({
    method: 'GET',
    uri: `/vehicles/${serialNumber}/revisions/notes`,
  })

export const addVehicleComment = ({ serialNumber, comment }) =>
  apiRequest({
    method: 'POST',
    uri: `/vehicles/${serialNumber}/revisions/add`,
    body: comment,
  })
